import React, { FC, ReactNode } from 'react';
import getClassName from 'src/common/utils/getClassName';
import s from './UpdateAvailability.module.scss';

type UpdateAvailabilityHeaderProps = {
  title: string;
  description: ReactNode;
  variant?: 'prompt';
};

const UpdateAvailabilityHeader: FC<UpdateAvailabilityHeaderProps> = ({
  title,
  description,
  variant,
}) => (
  <header className={getClassName(s, 'header', variant)}>
    <h3 className={s.title}>
      {title}
    </h3>
    <p className={s.description}>
      {description}
    </p>
  </header>
);

export default UpdateAvailabilityHeader;
